<template>
	<button class="v-switch" :type="type" :checked="value==onValue" @click="check" ref="input">
		<div class="v-switch-slider"></div>
	</button>
</template>

<script>
export default {
  props: {
    value: {
      default: null
    },
    type: {
      default: null
    },
    onValue: {
      default: true
    },
    offValue: {
      default: null
    }
  },
  methods: {
    check() {
      if (this.$attrs.disabled == null) {
        let { value, onValue, offValue } = this,
          result = value == onValue ? offValue : onValue;
        this.$emit("input", result), this.$emit("change", result);
      }
    }
  }
};
</script>

<style lang="less">
.v-switch {
  width: 40px;
  padding: 0px;
  border: none;
  outline: none;
  margin: 6px 0px;
  cursor: pointer;
  border-radius: 10px;
  display: inline-block;
  vertical-align: middle;
  filter: grayscale(100%);
  background-color: #41b883;
  transition: 300ms;
  > .v-switch-slider {
    margin: 2px;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    background-color: #ffffff;
    transition: 300ms;
  }
  &:active {
    > .v-switch-slider {
      transform: scale(0.7);
    }
  }
  &[checked] {
    filter: grayscale(0);
    > .v-switch-slider {
      transform: translateX(20px);
    }
    &:active {
      > .v-switch-slider {
        transform: translateX(20px) scale(0.7);
      }
    }
  }
  &[type="square"] {
    border-radius: 4px;
    > .v-switch-slider {
      border-radius: 2px;
    }
  }
  &[type="overflow"] {
    width: 32px;
    height: 14px;
    margin: 4px;
    border-radius: 7px;
    > .v-switch-slider {
      width: 18px;
      height: 18px;
      margin: 0px;
      border-radius: 9px;
      transform: translate3d(-3px, -2px, 0);
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
    }
    &:active {
      > .v-switch-slider {
        transform: translate3d(-3px, -2px, 0) scale(0.7);
      }
    }
    &[checked] {
      > .v-switch-slider {
        transform: translate3d(17px, -2px, 0);
      }
      &:active {
        > .v-switch-slider {
          transform: translate3d(17px, -2px, 0) scale(0.7);
        }
      }
    }
  }
  &[disabled] {
    cursor: no-drop;
    filter: grayscale(100%) brightness(80%);
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/switch.vue